module.exports = __webpack_public_path__ + "static/media/senexpay_screen.04bcd672.png";